export default __webpack_public_path__ + "images/onboarding/multiply-cb8b7198dcf1441367d1485db93c443a.svg";